import type { TeamMemberInfo } from '@shared/api';
import type { TeamSort } from '../../../lib/types';

const PERMISSION_RANK: Record<string, number> = {
  OWNER: 3,
  ADMIN: 2,
  MANAGER: 1,
};

const getJoinedAtTime = (value: string | undefined) => {
  const time = Date.parse(value ?? '');
  return Number.isNaN(time) ? 0 : time;
};

export const sortTeamMembers = (teamMembers: TeamMemberInfo[] | undefined, sort: TeamSort) => {
  if (!teamMembers?.length) return teamMembers;

  const isDesc = sort.startsWith('-');
  const sortKey = isDesc ? sort.slice(1) : sort;
  const direction = isDesc ? -1 : 1;

  return [...teamMembers].sort((firstMember, secondMember) => {
    if (sortKey === 'permission') {
      const firstRank = PERMISSION_RANK[firstMember.permission] ?? 0;
      const secondRank = PERMISSION_RANK[secondMember.permission] ?? 0;
      return (firstRank - secondRank) * direction;
    }

    if (sortKey === 'created_at') {
      const firstTime = getJoinedAtTime(firstMember.joined_at);
      const secondTime = getJoinedAtTime(secondMember.joined_at);
      return (firstTime - secondTime) * direction;
    }

    return 0;
  });
};
